import { AppStoreContext } from "@/store/utils/context";
import { useEffect } from "react";
import { useContext } from "react";

/**
 * When `active` is true, increments a global block counter that disables
 * all shortcuts registered in useAppKeyboardShortcuts. Decrements on
 * unmount or when `active` becomes false. Ref-counted so nested modals
 * that each call this hook will keep globals blocked until all close.
 */
export const useBlockGlobalHotkeys = (active: boolean) => {
  const client = useContext(AppStoreContext);

  useEffect(() => {
    if (!active || !client) return;

    client.store.interface.incrementGlobalHotkeyBlock();
    return () => client.store.interface.decrementGlobalHotkeyBlock();
  }, [active, client]);
};
